module.exports = __webpack_public_path__ + "static/media/gold11.bea9d7eb.png";